import ym from 'react-yandex-metrika';

export const sendYandexMetrica = ({
  parameter = 'reachGoal',
  params,
}: {
  parameter?: string;
  params?: any;
}) => {
  if (typeof window === 'undefined') return;

  const send = () => {
    if (typeof ym === 'function') {
      console.log('[YandexMetrica] send event:', { parameter, params });
      ym(parameter, params);
    } else {
      setTimeout(send, 100);
    }
  };

  send();
};
